import { extractSystemId } from "utils/utils";
import { TAGS_GROUP } from "constants/constantStrings";
import { TAG_TYPES } from "constants/globalConstants";

import { FETCH_ALL_TAGS, FETCH_TAGS_SUCCESS, POST_TAG_SUCCESS, RESET_TAGS_LIST, UPDATE_TAGS_VALUE } from "../actionTypes/tagsList";

const initialState = {
  tags: [],
  normalizedTags: [],
  tagsAsObj: {}
};

const customTagProps = {
  Group: "Formulae",
  TagType: "Formula",
  Type: "F",
  Units: "kgal",
  Value: 0,
  custom: true
};

/**
 * This is temporary implementation, so keeping these tags HARDCODED.
 */
const customTags = [
  {
    TagId: "CUSTOM_TAG024",
    TagName: "Total Permeate Produced",
    Description: "Total Permeate Produced",
    ...customTagProps
  },
  {
    TagId: "CUSTOM_TAG022",
    TagName: "Total Wastewater (Concentrate) Produced",
    Description: "Total Wastewater (Concentrate) Produced",
    ...customTagProps
  }
];

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_TAGS_LIST:
      return initialState;
    case FETCH_TAGS_SUCCESS:
      return fetchTagsSuccess(state, action);
    case UPDATE_TAGS_VALUE:
      return updateTags(state, action);
    case POST_TAG_SUCCESS:
      return onTagUpdateSuccess(state, action);
    case FETCH_ALL_TAGS:
      return fetchAllTags(state, action);
    default:
      return state;
  }
};

const formatTag = tag => {
  let { Units, Type, Value } = tag;
  Units = !Units || Units.toLowerCase() === "none" ? TAGS_GROUP.NA : Units;
  if (tag.Type === TAG_TYPES.NORMALIZED) {
    Value = "-";
  }
  return { ...tag, Units, Value, ...TAGS_GROUP[Type] };
};

function onTagUpdateSuccess(state, action) {
  const updatedTag = formatTag(action.payload);
  const updatedTagID = updatedTag.TagId;
  const { tags: tagList, tagsAsObj } = state;
  tagsAsObj[updatedTagID] = updatedTag;
  const tagIndex = tagList.findIndex(tag => tag.TagId === updatedTagID);
  tagList[tagIndex] = updatedTag;

  const newState = {
    ...state,
    tags: [...tagList],
    tagsAsObj: { ...tagsAsObj }
  };
  return newState;
}

const getFormattedTags = allTags => {
  const TAGS = { normalizedTags: [], standardTags: [] };
  return allTags.reduce((result, tag) => {
    const formattedVal = formatTag(tag);
    const key = tag.Type === TAG_TYPES.NORMALIZED ? "normalizedTags" : "standardTags";
    result[key].push(formattedVal);
    return result;
  }, TAGS);
};

function fetchTagsSuccess(state, action) {
  if (state.tags.length) {
    return state;
  }
  let newTags = [];
  // these should be for Dynegy System only
  if (extractSystemId() === "DYNEGY_1142C") {
    newTags = customTags;
  }
  const { tags } = action.payload;
  let { normalizedTags, standardTags } = getFormattedTags(tags);
  standardTags = [...standardTags, ...newTags];
  const tagsAsObj = convertListIntoObj([...normalizedTags, ...standardTags]);
  return {
    ...state,
    tags: standardTags,
    normalizedTags,
    tagsAsObj
  };
}

function fetchAllTags(state, action) {
  let newTags = [];
  // these should be for Dynegy System only
  if (extractSystemId() === "DYNEGY_1142C") {
    newTags = customTags;
  }
  const { tags } = action.payload;
  let { normalizedTags, standardTags } = getFormattedTags(tags);
  standardTags = [...standardTags, ...newTags];
  const tagsAsObj = convertListIntoObj([...normalizedTags, ...standardTags]);
  return {
    ...state,
    tags: standardTags,
    normalizedTags,
    tagsAsObj
  };
}

function updateTags(state, action) {
  const { updatedTags } = action.payload;
  const { tagsAsObj } = state;
  Object.entries(updatedTags).forEach(([TagId, Value]) => {
    if (tagsAsObj[TagId]) {
      tagsAsObj[TagId].Value = Value;
    }
  });
  return {
    ...state,
    tagsAsObj
  };
}

const convertListIntoObj = tagsList => tagsList.reduce((result, tag) => ({ ...result, [tag.TagId]: tag }), {});

export default reducer;
